<h2 mat-dialog-title>Entrevistas</h2>
<mat-dialog-content>

    <div class="interviews">
        <div class="interview-list">

            <mat-action-list>
                <button mat-list-item *ngFor="let item of interviews" (click)="openSelectionTest(item)"
                    [ngClass]="{ 'actived': item.id == formInterview.get('id').value }">
                    
                    <h3 matLine>{{ item.name }}</h3>                    
                    <p matLine>
                        {{ item.date_start | date: 'dd/MM/yyyy' }} às {{ formatTime(item.time_start) }}
                        <ng-container *ngIf="item.time_end">
                            até {{formatTime(item.time_end)}}
                        </ng-container>
                    </p>
                    <p matLine style="margin-bottom: 0;"> Tipo: {{ item.type === 'true' ? 'Entrevista Remota' : 'Entrevista Presencial' }}</p>
                    <span matLine *ngIf="item.type === 'false'">{{ item.address }}</span>
                    <span matLine>Falar com {{ item.contact }}</span>
                    
                    <button color="primary" mat-icon-button matTooltip="Agendar entrevista"
                        (click)="openInterviewSession(item)">
                        <mat-icon>event</mat-icon>
                    </button>

                    <button color="warn" mat-icon-button *ngIf="currentProcessList.status === 'read'"
                        (click)="deleteInterview($event, item)">
                        <mat-icon>delete</mat-icon>
                    </button>
                </button>
            </mat-action-list>

            <div class="empty-content" *ngIf="interviews.length === 0">                    
                <span class="mat-body-2">Nenhuma entrevista agendada ainda.</span>        
            </div>

        </div>
        <div class="interview-form">

            <div class="controls" [hidden]="submiting">

                <ng-container>
                    <button mat-stroked-button color="primary" (click)="newInterview()" *ngIf="selectInterviewMode === false"
                        >Cadastrar entrevistas</button>
                </ng-container>

                <button mat-raised-button color="primary" (click)="submitInterview()"
                    *ngIf="selectInterviewMode">Salvar</button>
                <button mat-button color="accent" (click)="selectInterviewMode = false" *ngIf="selectInterviewMode">Cancelar</button>
            </div>

            <form [formGroup]="formInterview" *ngIf="selectInterviewMode">

                <div class="row">
                    <mat-form-field appearance="outline">
                        <mat-label>Nome da entrevista</mat-label>
                        <input matInput type="text" placeholder="Nome da entrevista" formControlName="name" />
                    </mat-form-field>
                </div>

                <div class="row">
                    <mat-form-field appearance="outline" class="hora">
                        <mat-label>Data</mat-label>
                        <input matInput type="date" placeholder="Dia da entrevista" formControlName="dateStart" />
                        <mat-error *ngIf="formInterview.get('dateStart').errors?.minDate">A data da entrevista não pode ser anterior à data atual.</mat-error>
                    </mat-form-field>
                
                    <mat-form-field appearance="outline" class="hora">
                        <mat-label>Horário inicial</mat-label>
                        <input matInput type="time" placeholder="Horário de inicio da entrevista" formControlName="timeStart" />
                        <mat-error *ngIf="formInterview.get('timeStart').errors?.beforeDate">O horário de início da entrevista deve ser anterior ao horário de término.</mat-error>
                        <mat-error *ngIf="formInterview.get('timeStart').errors?.invalidDate">Informe um horário válido</mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="hora">
                        <mat-label>Horário final</mat-label>
                        <input matInput type="time" placeholder="Horário  final da entrevista" formControlName="timeEnd" />
                        <mat-error *ngIf="formInterview.get('timeEnd').errors?.afterDate">O horário de término da entrevista deve ser posterior ao horário de início.</mat-error>
                        <mat-error *ngIf="formInterview.get('timeEnd').errors?.invalidDate">Informe um horário válido</mat-error>
                    </mat-form-field>
                </div>

                <div class="row" style="padding-bottom: 6px;">
                    <!--<div class="row">
                        <mat-slide-toggle color="primary" formControlName="nextDays">Extender para os próximos dias úteis, caso não for possivel agendar todos candidatos nesse dia e horário</mat-slide-toggle>
                    </div>-->
                
                    <mat-form-field appearance="outline" class="hora">
                        <mat-label>Duração da entrevista</mat-label>
                        <input matInput type="time" min="0" placeholder="Duração da entrevista por candidato" formControlName="candidatesSessionDuration" />
                        <mat-hint>Em horas/minutos</mat-hint>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Contato da entrevista</mat-label>
                        <input matInput type="text" placeholder="Nome do contato para entrevista" formControlName="contact" />
                    </mat-form-field>
                </div>
                
                <p style="margin-left: 6px;">Tipo de Entrevista:</p>
                <div class="row align-center">
                    <span>Presencial</span>
                    <mat-slide-toggle 
                      color="primary" 
                      formControlName="type" 
                      (change)="onToggleChange($event)"
                      style="margin-top: -4px;">
                    </mat-slide-toggle>
                    <span>Remota</span>
                    <br>
                </div>

                <div *ngIf="!formInterview.get('type')?.value" class="address-field">
                    <!-- <div class="row">
                        <mat-form-field appearance="outline">
                            <mat-label>Endereço do local</mat-label>
                            <input matInput #autocomplete id="autocomplete" type="text" placeholder="Digite o Endereço do local de entrevista..." formControlName="address"/>
                        </mat-form-field>
                    </div> -->
                    <fieldset>
                        <legend>Endereço do local</legend>
                    
                        <div class="row">
                            <mat-form-field appearance="outline">
                                <mat-label>Numero</mat-label>
                                <input
                                matInput
                                type="text"
                                placeholder="Informe numero"
                                formControlName="number"
                                inputmode="numeric"
                                />
                            </mat-form-field>
                            <mat-form-field appearance="outline">
                                <mat-label>Cep</mat-label>
                                <input
                                    type="text"
                                    matInput
                                    placeholder="Informe o cep"
                                    formControlName="zipCode"
                                    mask="00000-000"
                                    inputmode="numeric"
                                />
                            </mat-form-field>
                        </div>    
                    
                        <div class="row">
                          <mat-form-field appearance="outline">
                            <mat-label>Endereço</mat-label>
                            <input
                              matInput
                              type="text"
                              placeholder="Informe o Endereço do local de entrevista"
                              formControlName="address"
                            />
                          </mat-form-field>
                        </div>
                    </fieldset>
                </div>

                <div class="actions" [hidden]="submiting">
                    <button mat-raised-button color="primary" (click)="submitInterview()" type="submit"
                        *ngIf="selectInterviewMode">Salvar</button>
                </div>

            </form>            

        </div>
    </div>

</mat-dialog-content>
<mat-progress-bar color="primary" mode="indeterminate" *ngIf="submiting"></mat-progress-bar>
<mat-dialog-actions *ngIf="!submiting">
    <button color="accent" mat-dialog-close mat-button>Fechar</button>
</mat-dialog-actions>